<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";

    export let type: 'information' | 'success' | 'warning' | 'danger' = 'information';

    $: icon = (() => {
        switch (type) {
            case 'warning':
                return 'triangle-exclamation';
            case 'danger':
                return 'circle-exclamation';
        }
        return "circle-info";
    })();

    onMount(() => {
    });


</script>

<div class={`tips-message-area-view ${type}`}>
    <div class="icon-area">
        <FontAwesomeView icon="circle-info"/>
    </div>
    <div class="message-area">
        <slot/>
    </div>


</div>


<style lang="scss">
    .tips-message-area-view {
        display: flex;
        margin: 1em;
        gap: 1em;
        padding: 0.5em;
        background-color: #fff9;
        font-size: 0.75em;

        border-style: solid;
        border-width: 1px;
        border-color: #0003;
        border-radius: 4px;

        .message-area {
            white-space: pre-line;
        }

        &.warning {
            border-color: var(--warning-color);
            color: var(--warning-text-color);
            background-color: var(--warning-color);
        }

        &.danger {
            border-color: var(--danger-color);
            color: var(--danger-text-color);
            background-color: var(--danger-color);
        }

    }
</style>